import React from 'react';
import BookList from './BookList';
import Bracket from './Bracket';
import Home from './Home';
import SideBarLayout from './SideBarLayout';

const pages = [['home', <Home />],['bracket', <Bracket />], ['standings', <p>standings</p>],['admin',<p>admin page</p>]]

function MarchMadness(){
    return (
        <SideBarLayout pages={pages} />
    )
}

export default MarchMadness;